import { render, staticRenderFns } from "./SelectableRiseupButton.vue?vue&type=template&id=5bbdaf09&scoped=true"
import script from "./SelectableRiseupButton.vue?vue&type=script&lang=js"
export * from "./SelectableRiseupButton.vue?vue&type=script&lang=js"
import style0 from "./SelectableRiseupButton.vue?vue&type=style&index=0&id=5bbdaf09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbdaf09",
  null
  
)

export default component.exports